import { get, withAuth } from "./base";

const getSearch = (keyword = "") => {
  return get(`warehouses?name=${keyword}`, withAuth());
};

export default { getSearch };
